const track = (eventName, params) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', eventName, params);
};

export const trackNationalTypePageUseLocation = ({ typeSlug, source } = {}) => {
  track('national_type_page_use_location', {
    type_slug: typeSlug,
    source,
  });
};

export const trackNationalTypePageNearbyResults = ({ typeSlug } = {}) => {
  track('national_type_page_nearby_results', {
    type_slug: typeSlug,
  });
};
